document.addEventListener('DOMContentLoaded', () => {
  /* ============================================
   * 竣工事例カルーセル（横スクロール + 矢印 + ドット）
   * 前後に複製スライドを差し込んで無限スクロールにする
   * ============================================ */
  const carousel = document.querySelector('[data-carousel]');
  if (carousel) {
    const track = carousel.querySelector('[data-carousel-track]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const dots = Array.from(carousel.querySelectorAll('[data-carousel-dots] span'));
    const originalSlides = Array.from(track.children);
    const slideCount = originalSlides.length;

    let slides = originalSlides;
    let looping = false;

    const centerLeft = (slide) => slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;

    // 現在中央に最も近いスライド（複製含む）の index を返す
    const currentIndex = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      let closest = 0;
      let min = Infinity;
      slides.forEach((slide, i) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const dist = Math.abs(slideCenter - center);
        if (dist < min) {
          min = dist;
          closest = i;
        }
      });
      return closest;
    };

    // ループ中の index を実スライド（0〜slideCount-1）の index に変換
    const toRealIndex = (index) => (looping ? ((index - 1) + slideCount) % slideCount : index);

    const scrollToIndex = (index, smooth) => {
      const slide = slides[index];
      if (!slide) return;
      // track には CSS で scroll-behavior: smooth が指定されているため、
      // behavior: 'auto' を指定してもスムーズスクロールになってしまう。
      // ループ端での瞬間ジャンプを本当に瞬時にするには 'instant' を明示する。
      track.scrollTo({ left: centerLeft(slide), behavior: smooth ? 'smooth' : 'instant' });
    };

    const syncDots = () => {
      const idx = toRealIndex(currentIndex());
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
    };

    // 先頭に末尾スライドの複製、末尾に先頭スライドの複製を差し込む
    const enableLoop = () => {
      if (looping || slideCount < 2) return;
      const headClone = originalSlides[0].cloneNode(true);
      const tailClone = originalSlides[slideCount - 1].cloneNode(true);
      headClone.setAttribute('data-clone', '');
      tailClone.setAttribute('data-clone', '');
      headClone.setAttribute('aria-hidden', 'true');
      tailClone.setAttribute('aria-hidden', 'true');
      track.insertBefore(tailClone, originalSlides[0]);
      track.appendChild(headClone);
      slides = Array.from(track.children);
      looping = true;
      scrollToIndex(1, false);
    };

    // 複製スライドで止まったら、反対端の実スライドへ瞬時に飛ばしてループさせる
    const handleSettle = () => {
      const idx = currentIndex();
      if (idx === 0) {
        scrollToIndex(slideCount, false);
      } else if (idx === slides.length - 1) {
        scrollToIndex(1, false);
      }
    };

    const goTo = (realIndex) => {
      scrollToIndex(realIndex + 1, true);
    };

    prev && prev.addEventListener('click', () => goTo(toRealIndex(currentIndex()) - 1));
    next && next.addEventListener('click', () => goTo(toRealIndex(currentIndex()) + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    let ticking = false;
    let settleTimer = null;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        syncDots();
        ticking = false;
      });

      clearTimeout(settleTimer);
      settleTimer = setTimeout(handleSettle, 120);
    });

    enableLoop();
    syncDots();

    // 自動再生（一定間隔で次のスライドへ。操作中・非表示中は停止）
    const AUTO_LOOP_INTERVAL = 4000;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let autoLoopTimer = null;

    const stopAutoLoop = () => {
      clearInterval(autoLoopTimer);
      autoLoopTimer = null;
    };

    const startAutoLoop = () => {
      if (prefersReducedMotion || slideCount < 2 || document.hidden) return;
      stopAutoLoop();
      autoLoopTimer = setInterval(() => {
        goTo(toRealIndex(currentIndex()) + 1);
      }, AUTO_LOOP_INTERVAL);
    };

    carousel.addEventListener('mouseenter', stopAutoLoop);
    carousel.addEventListener('mouseleave', startAutoLoop);
    carousel.addEventListener('pointerdown', stopAutoLoop);
    carousel.addEventListener('pointerup', startAutoLoop);
    prev && prev.addEventListener('click', startAutoLoop);
    next && next.addEventListener('click', startAutoLoop);
    dots.forEach((dot) => dot.addEventListener('click', startAutoLoop));
    document.addEventListener('visibilitychange', () => {
      document.hidden ? stopAutoLoop() : startAutoLoop();
    });

    startAutoLoop();
  }

  /* ============================================
   * ページ内アンカーリンク
   * Webフォント読み込み前にスクロールすると、フォント適用時の
   * リフローで着地位置がずれるため、フォント読み込み完了を待ってから遷移する
   * ============================================ */
  const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');
  if (anchorLinks.length) {
    const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();

    anchorLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;

        e.preventDefault();
        fontsReady.then(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.pushState(null, '', link.hash);
        });
      });
    });
  }

  /* ============================================
   * PAGE TOP
   * ============================================ */
  const pagetop = document.querySelector('[data-pagetop]');
  if (pagetop) {
    pagetop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ============================================
   * ヘッダーの白背景切り替え（ナビカード到達で付与）
   * ============================================ */
  const header = document.querySelector('.l-header');
  const navCards = document.querySelector('.p-nav-cards');
  if (header && navCards) {
    const toggleHeaderBg = () => {
      const reached = navCards.getBoundingClientRect().top <= header.offsetHeight;
      header.classList.toggle('white-bg', reached);
    };

    toggleHeaderBg();

    let bgTicking = false;
    window.addEventListener('scroll', () => {
      if (bgTicking) return;
      bgTicking = true;
      window.requestAnimationFrame(() => {
        toggleHeaderBg();
        bgTicking = false;
      });
    });
  }

  /* ============================================
   * ヘッダーのメニュートグル（SPドロワー開閉）
   * ============================================ */
  const toggle = header && header.querySelector('.l-header__toggle');
  if (header && toggle) {
    const setOpen = (open) => {
      header.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    };

    toggle.addEventListener('click', () => {
      setOpen(!header.classList.contains('is-open'));
    });

    // ドロワー内リンクをタップしたら閉じる
    header.querySelectorAll('.l-header__drawer a').forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });

    // Esc で閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && header.classList.contains('is-open')) {
        setOpen(false);
      }
    });
  }

  /* ============================================
   * タブUI切り替え（キャリアパスの職種タブなど）
   * aria-controls で対応するパネルを表示/非表示にする
   * ============================================ */
  document.querySelectorAll('[role="tablist"]').forEach((tablist) => {
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    const activate = (tab) => {
      tabs.forEach((t) => {
        const selected = t === tab;
        t.classList.toggle('is-active', selected);
        t.setAttribute('aria-selected', String(selected));
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) {
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
        }
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab));
    });
  });
});
